export enum ProjectUpdateTypes {
  revisionUpdated = 'RevisionUpdated',
  itemAdded = 'ItemAdded',
  itemRemoved = 'ItemRemoved',
  itemUpdated = 'ItemUpdated',
  propertiesUpdated = 'PropertiesUpdated'
}
